import axios from "axios";

axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.timeout = 8000;
axios.defaults.headers.common["X-CSRFToken"] = ``;
// axios.defaults.headers.common["Authorization"] = `Bearer ${
//   JSON.parse(localStorage.getItem("token")) || null
// }`;

export const fetcher = (url) => axios.get(url).then((res) => res.data);

export const fetcherGetToken = (url) =>
  axios
    .get(url[0], {
      headers: url[1] && {
        Authorization: `Bearer ${url[1]}`,
      },
    })
    .then((res) => res.data);

export const fetcherPatch = (url, { arg }) =>
  axios
    .patch(url[0], arg, {
      headers: url[1] && {
        Authorization: `Bearer ${url[1]}`,
      },
    })
    .then((res) => res.data);

export const fetcherPost = (url, { arg }) =>
  axios
    .post(url[0], arg, {
      headers: url[1] && {
        Authorization: `Bearer ${url[1]}`,
      },
    })
    .then((res) => res.data);
